// extracted by mini-css-extract-plugin
module.exports = {"Title":"Attachment__Title_FTQ4K","Footer":"Attachment__Footer_2RqhV","Link":"Attachment__Link_1Cz8i"};